module.exports = __webpack_public_path__ + "media/images/facebook-copper-05a27e6106452fe3e31248d60926154c.svg";